// @material-ui/core components
import { createMuiTheme } from "@material-ui/core/styles";
// core components
import baseTheme from "assets/theme/theme.js";

const theme = createMuiTheme(baseTheme, {
  direction: "rtl",
});

export default theme;
